import RemoteContentController from './remote_content_controller.js';

export default class extends RemoteContentController {
  connect() {
    this.load();
  }
}
